import type { paths } from '@luxuryescapes/contract-trip'
import request from 'api/requestUtils'
import { baseUri, getOptions, throwIfAborted } from './utils'

// Longer than svc-trip's own 5s budget for a check, so a hung request still frees the nudge.
const TRIP_DETAILS_CHECK_TIMEOUT_MS = 8_000

type CheckTripDetailsOperation = paths['/api/trips/v2/trip-details/check']['post']
type CheckTripDetailsRequest = CheckTripDetailsOperation['requestBody']['content']['application/json']
type CheckTripDetailsApiResponse = CheckTripDetailsOperation['responses']['200']['content']['application/json']

export type TripDetailsCheck = CheckTripDetailsApiResponse['result']

export type TripDetail = keyof TripDetailsCheck

/** Which trip details a draft message mentions */
export async function checkTripDetails(text: string, signal?: AbortSignal): Promise<TripDetailsCheck> {
  const response = await request.post<CheckTripDetailsApiResponse, CheckTripDetailsRequest>(
    `${baseUri}/v2/trip-details/check`,
    { text },
    { ...getOptions(), timeout: TRIP_DETAILS_CHECK_TIMEOUT_MS, signal },
  )
  return throwIfAborted(response).result
}
